<script>
import Vue from 'vue'
import { AgGridVue } from 'ag-grid-vue'

import RuleResource from '../../resources/rule'
import toastMixin from '../../mixins/toast'

export default Vue.extend({
    name: 'RuleGrid',
    components: {
        AgGridVue,
    },
    props: {},
    mixins: [toastMixin],
    data() {
        return {
            ruleColumnDefs: [
                {
                    field: 'id',
                    headerName: 'ID#',
                    sortable: true,
                    valueSetter: () => null,
                    valueGetter: (params) => {
                        return params.data.id
                    },
                },
                {
                    field: 'name',
                    headerName: 'Name',
                    sortable: true,
                    editable: true,
                    valueSetter: (params) => {
                        params.data.attributes.value.name = params.newValue
                        params.data.set('name', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.name
                    },
                },
                {
                    field: 'description',
                    headerName: 'Description',
                    sortable: true,
                    editable: true,
                    valueSetter: (params) => {
                        params.data.attributes.value.description = params.newValue
                        params.data.set('description', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.description
                    },
                },
                {
                    field: 'type',
                    headerName: 'Type',
                    sortable: true,
                    editable: true,
                    valueSetter: (params) => {
                        params.data.attributes.value.type = params.newValue
                        params.data.set('type', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.type
                    },
                },
                {
                    field: 'bucket',
                    minWidth: 100,
                    headerName: 'Bucket',
                    sortable: true,
                    editable: true,
                    valueSetter: (params) => {
                        params.data.attributes.value.bucket = params.newValue
                        params.data.set('bucket', params.newValue)
                    },
                    valueGetter: (params) => {
                        // return params.data.get('bucket')
                        return params.data.attributes.value.bucket
                    },
                },
                {
                    field: 'ext_payroll_code',
                    headerName: 'Apex Pay Code',
                    sortable: true,
                    editable: true,
                    valueSetter: (params) => {
                        params.data.attributes.value.ext_payroll_code = params.newValue
                        params.data.set('ext_payroll_code', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.value.ext_payroll_code
                    },
                },
                {
                    field: 'propay_id',
                    headerName: 'PP Pay Code',
                    sortable: true,
                    editable: true,
                    valueSetter: (params) => {
                        params.data.attributes.value.propay_id = params.newValue
                        params.data.set('propay_id', params.newValue)
                        //if (!params.data.changes) params.data.changes = {}
                        //params.data.changes.value = params.data.attributes.value
                        //debugger
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.value.propay_id
                    },
                },
                {
                    field: 'op_type',
                    headerName: 'Operation Type',
                    sortable: true,
                    editable: true,
                    valueSetter: (params) => {
                        params.data.attributes.value.op_type = params.newValue
                        params.data.set('op_type', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.value.op_type
                    },
                },
                {
                    field: 'op_value',
                    headerName: 'Operation Value',
                    sortable: true,
                    editable: true,
                    valueSetter: (params) => {
                        params.data.attributes.value.op_value = params.newValue
                        params.data.set('op_value', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.value.op_value
                    },
                },
                {
                    field: 'day_type_id',
                    headerName: 'Day Type',
                    sortable: true,
                    editable: true,
                    valueSetter: (params) => {
                        params.data.attributes.value.day_type_id = params.newValue
                        params.data.set('day_type_id', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.value.day_type_id
                    },
                },
                {
                    field: 'increment_value',
                    headerName: 'Increment Value',
                    sortable: true,
                    editable: true,
                    valueSetter: (params) => {
                        params.data.attributes.value.increment_value = params.newValue
                        params.data.set('increment_value', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.value.increment_value
                    },
                },
                {
                    field: 'value',
                    headerName: 'Value',
                    sortable: true,
                    editable: true,
                    valueSetter: (params) => {
                        params.data.attributes.value.value = params.newValue
                        params.data.set('value', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.value.value
                    },
                },
                {
                    field: 'comps',
                    headerName: 'Comps',
                    sortable: true,
                    editable: true,
                    minWidth: 800,
                    valueSetter: (params) => {
                        params.data.attributes.value.comps = params.newValue
                        params.data.set('comps', params.newValue)
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.value.comps ? JSON.stringify(params.data.attributes.value.comps) : ''
                    },
                },
            ],
            ruleRowData: [],
            ruleGridOptions: {
                enterMovesDown: true,
                enterMovesDownAfterEdit: true,
                defaultColDef: {
                    resizable: true,
                    singleClickEdit: true,
                    undoRedoCellEditing: true,
                    enterMovesDown: true,
                    enterMovesDownAfterEdit: true,
                },
                onGridReady: (params) => {
                    if (params) {
                        this.gridApi = params.api
                        this.columnApi = params.columnApi
                    }
                },

                onFirstDataRendered: (params) => {
                    params.api.sizeColumnsToFit()
                },
            },
        }
    },
    computed: {
        resources() {
            return {
                RuleResource,
            }
        },
    },
    methods: {
        selectRule(params) {
            if (params && params.data && params.data.attributes) this.$emit('select', params.data)
        },

        async saveGrid() {
            let changes = false
            if (!this.ruleRowData || !this.ruleRowData.length) {
                this.createToast('b-toaster-top-center', 'warning', true, 'Warning', 'No Data to Save')
                return false
            }

            this.ruleRowData.forEach(async (row) => {
                if (row.changes && Object.keys(row.changes).length) {
                    changes = true
                    row.validate()
                    try {
                        await row.save()
                        row.changes = {}
                    } catch (error) {
                        this.createToast('b-toaster-top-center', 'danger', true, 'Save Error', error, true)
                        throw error
                    }
                }
            })

            if (!changes) this.createToast('b-toaster-top-center', 'warning', true, 'Warning', 'No Data to Save')
            else this.createToast('b-toaster-top-center', 'success', true, 'Success', 'Finished Save')
        },

        exportGrid() {
            this.gridApi.exportDataAsExcel()
        },
    },

    async mounted() {
        this.ruleRowData = await RuleResource.all()
    },
})
</script>

<template>
    <div>
        <h1>Rules Grid</h1>
        <div class="right">
            <b-button variant="outline-success" @click="exportGrid">Export</b-button>
            <b-button variant="primary" @click="saveGrid">Save</b-button>
        </div>
        <div class="clear"></div>
        <ag-grid-vue class="ag-theme-balham default-grid" :grid-options="ruleGridOptions" :column-defs="ruleColumnDefs" :row-data="ruleRowData" @row-clicked="selectRule" />
        <div class="clear"></div>
        <div class="right">
            <b-button variant="outline-success" @click="exportGrid">Export</b-button>
            <b-button variant="primary" @click="saveGrid">Save</b-button>
        </div>
        <div class="clear"></div>
        <hr />
    </div>
</template>

<style>
@import '../../../node_modules/ag-grid-community/dist/styles/ag-grid.css';
@import '../../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css';

.default-grid {
    width: 100%;
    height: 200px;
}
</style>
